//------------------------------------------------------------------------
// Expand toggles (used in Methodology)
//-----------------------------------------------------------------------
import ExpandToggle from '@threespot/expand-toggle';

export default class IntroToggle {
  constructor(el) {
    this.el = el;
    if (!this.el) {
      console.warn(`Unable to initialize expandable intro, no matching element for “${this.el}”`);
      return false;
    }

    this.expandToggle = new ExpandToggle(el);

    // Update expandable height once web fonts have loaded
    document.documentElement.addEventListener('fonts-loaded', () => {
      this.expandToggle.updateExpandedHeight();
    });

    // Update expandable height after a Methodology chart loads
    if (this.el.getAttribute('data-expands') == 'methodology-content') {
      document.documentElement.addEventListener('resize-methodology', () => {
        this.expandToggle.updateExpandedHeight();
      });
    }
  }
}
